// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DisplayUnit.css */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.site-header {
  background-color: #f1f1f1;
  border-bottom: 3px solid #333;
  padding: 20px 0;
}

.content-area {
  display: flex;
  flex-direction: column;
}

.unit-content {
  flex-grow: 1;
}

.site-footer {
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 20px 0;
}

/* Add styles for individual components */
.site-header h1 {
  margin: 0;
  padding: 10px 0;
  font-size: 24px;
}

.unit-content {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

/* Add styles for form elements */
form {
  max-width: 600px;
  margin: 0 auto;
}

input[type="file"] {
  width: 100%;
}

/* Add styles for buttons */
.button {
  display: inline-block;
  background: #007bff;
  color: #fff;
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.button:hover {
  background-color: #0056b3;
}

/* Add styles for typography */
p {
  margin-bottom: 15px;
}

h1, h2, h3 {
  margin-top: 20px;
}

h2 {
  margin-bottom: 15px;
}

h3 {
  margin-bottom: 10px;
}

/* Add styles for React Quill editor */
.react-quill {
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Add styles for PDF viewer */
.stypdf {
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
}

.stypdf iframe {
  width: 100%;
  height: 400px;
  border: none;
}

/* Add styles for loading spinner */
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner > div {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.content-section
 {
    position: relative;
    padding: 42px 20px 20px 20px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.react-pdf__Page{
  padding-top: 15px;
  width: 100% !important;
  height: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Units/EditUnit.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;IAEI,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":["/* DisplayUnit.css */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.site-header {\n  background-color: #f1f1f1;\n  border-bottom: 3px solid #333;\n  padding: 20px 0;\n}\n\n.content-area {\n  display: flex;\n  flex-direction: column;\n}\n\n.unit-content {\n  flex-grow: 1;\n}\n\n.site-footer {\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  padding: 20px 0;\n}\n\n/* Add styles for individual components */\n.site-header h1 {\n  margin: 0;\n  padding: 10px 0;\n  font-size: 24px;\n}\n\n.unit-content {\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n/* Add styles for form elements */\nform {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\ninput[type=\"file\"] {\n  width: 100%;\n}\n\n/* Add styles for buttons */\n.button {\n  display: inline-block;\n  background: #007bff;\n  color: #fff;\n  padding: 10px 20px;\n  text-decoration: none;\n  border-radius: 5px;\n  transition: background-color 0.3s;\n}\n\n.button:hover {\n  background-color: #0056b3;\n}\n\n/* Add styles for typography */\np {\n  margin-bottom: 15px;\n}\n\nh1, h2, h3 {\n  margin-top: 20px;\n}\n\nh2 {\n  margin-bottom: 15px;\n}\n\nh3 {\n  margin-bottom: 10px;\n}\n\n/* Add styles for React Quill editor */\n.react-quill {\n  height: 300px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n/* Add styles for PDF viewer */\n.stypdf {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.stypdf iframe {\n  width: 100%;\n  height: 400px;\n  border: none;\n}\n\n/* Add styles for loading spinner */\n.spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.spinner > div {\n  width: 50px;\n  height: 50px;\n  border: 5px solid #f3f3f3;\n  border-top: 5px solid #3498db;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.content-section\n {\n    position: relative;\n    padding: 42px 20px 20px 20px;\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n}\n\n.react-pdf__Page{\n  padding-top: 15px;\n  width: 100% !important;\n  height: auto !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
